// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Wizard-module_wrapper_96245","container":"Wizard-module_container_a638b","line":"Wizard-module_line_24442","stepText":"Wizard-module_stepText_debd6"};